import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { fmtDate } from "../../lib/format";

export default function NewsCard({ article, index = 0, example = false }) {
  const to = example ? "/actualites" : `/actualites/${article.slug}`;
  const excerpt = article.excerpt || (article.content || "").split("\n")[0]?.slice(0, 140);
  const [portrait, setPortrait] = useState(false);

  useEffect(() => {
    setPortrait(false);
  }, [article.image]);

  return (
    <Link
      to={to}
      data-testid={`news-card-${index}`}
      className="group block bg-white border border-navy/10 hover:border-rouge/60 transition-[border-color] duration-300"
    >
      <div className="relative overflow-hidden aspect-[4/3] bg-navy">
        {article.image && (
          <img
            src={article.image}
            alt=""
            aria-hidden="true"
            className="hidden"
            onLoad={(e) => setPortrait(e.target.naturalHeight > e.target.naturalWidth)}
          />
        )}
        {article.image ? (
          <img
            src={article.image}
            alt={article.title}
            loading="lazy"
            className={
              portrait
                ? "w-full h-full object-contain transition-transform duration-700 group-hover:scale-105"
                : "w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            }
          />
        ) : (
          <div className="w-full h-full bg-navy2" />
        )}
        <span className="absolute top-4 left-4 bg-rouge text-white text-[10px] font-bold uppercase tracking-[0.2em] px-3 py-1.5">
          {article.category}
        </span>
        {example && (
          <span data-testid="example-badge" className="absolute top-4 right-4 bg-navy text-white text-[10px] font-bold uppercase tracking-[0.2em] px-3 py-1.5">
            Exemple
          </span>
        )}
      </div>
      <div className="p-6">
        <p className="text-xs text-steel uppercase tracking-widest font-semibold">
          {fmtDate(article.date)} · {article.author}
        </p>
        <h3 className="mt-3 font-heading uppercase font-semibold tracking-tight text-navy text-xl leading-tight group-hover:text-rouge transition-colors duration-300">
          {article.title}
        </h3>
        {excerpt && <p className="mt-3 text-sm text-steel line-clamp-2">{excerpt}</p>}
        <span className="mt-5 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-navy group-hover:text-rouge transition-colors duration-300">
          Lire l'article
          <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
        </span>
      </div>
    </Link>
  );
}
